import { useState } from 'react'

import type { PaginationState } from '@tanstack/react-table'

export function usePaginationState(initialState: PaginationState) {
  const [paginationState, setPaginationState] =
    useState<PaginationState>(initialState)

  return { paginationState, setPaginationState }
}
